var cov_1hrh1reqyt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/DatePicker/Range.tsx",
      hash = "d8f3a0d6eee7b1d3d4719a0a2f442b807c4aeb97",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/DatePicker/Range.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 21
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 16
        }
      },
      "2": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "3": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 21
        }
      },
      "4": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 52
        }
      },
      "5": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 60
        }
      },
      "6": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 61
        }
      },
      "7": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 56
        }
      },
      "8": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 56
        }
      },
      "9": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 57
        }
      },
      "10": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 70
        }
      },
      "11": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 66
        }
      },
      "12": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 58
        }
      },
      "13": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 50
        }
      },
      "14": {
        start: {
          line: 74,
          column: 26
        },
        end: {
          line: 74,
          column: 36
        }
      },
      "15": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "16": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 52
        }
      },
      "17": {
        start: {
          line: 86,
          column: 25
        },
        end: {
          line: 86,
          column: 35
        }
      },
      "18": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 63
        }
      },
      "19": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 28
        }
      },
      "20": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 32
        }
      },
      "21": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 103,
          column: 5
        }
      },
      "22": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 86
        }
      },
      "23": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 107,
          column: 46
        }
      },
      "24": {
        start: {
          line: 107,
          column: 40
        },
        end: {
          line: 107,
          column: 46
        }
      },
      "25": {
        start: {
          line: 108,
          column: 19
        },
        end: {
          line: 108,
          column: 28
        }
      },
      "26": {
        start: {
          line: 109,
          column: 22
        },
        end: {
          line: 109,
          column: 32
        }
      },
      "27": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 113,
          column: 5
        }
      },
      "28": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 112,
          column: 68
        }
      },
      "29": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 68
        }
      },
      "30": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "31": {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 57
        }
      },
      "32": {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 116,
          column: 66
        }
      },
      "33": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 73
        }
      },
      "34": {
        start: {
          line: 131,
          column: 18
        },
        end: {
          line: 131,
          column: 77
        }
      },
      "35": {
        start: {
          line: 132,
          column: 38
        },
        end: {
          line: 132,
          column: 48
        }
      },
      "36": {
        start: {
          line: 134,
          column: 33
        },
        end: {
          line: 134,
          column: 74
        }
      },
      "37": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 141,
          column: 5
        }
      },
      "38": {
        start: {
          line: 136,
          column: 22
        },
        end: {
          line: 138,
          column: 8
        }
      },
      "39": {
        start: {
          line: 137,
          column: 8
        },
        end: {
          line: 137,
          column: 30
        }
      },
      "40": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 59
        }
      },
      "41": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 12
        }
      },
      "42": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "43": {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 174,
          column: 7
        }
      },
      "44": {
        start: {
          line: 147,
          column: 10
        },
        end: {
          line: 147,
          column: 42
        }
      },
      "45": {
        start: {
          line: 148,
          column: 25
        },
        end: {
          line: 148,
          column: 40
        }
      },
      "46": {
        start: {
          line: 149,
          column: 10
        },
        end: {
          line: 156,
          column: 11
        }
      },
      "47": {
        start: {
          line: 150,
          column: 12
        },
        end: {
          line: 154,
          column: 13
        }
      },
      "48": {
        start: {
          line: 151,
          column: 14
        },
        end: {
          line: 153,
          column: 15
        }
      },
      "49": {
        start: {
          line: 152,
          column: 16
        },
        end: {
          line: 152,
          column: 44
        }
      },
      "50": {
        start: {
          line: 155,
          column: 12
        },
        end: {
          line: 155,
          column: 18
        }
      },
      "51": {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 160,
          column: 11
        }
      },
      "52": {
        start: {
          line: 158,
          column: 12
        },
        end: {
          line: 158,
          column: 36
        }
      },
      "53": {
        start: {
          line: 159,
          column: 12
        },
        end: {
          line: 159,
          column: 47
        }
      },
      "54": {
        start: {
          line: 161,
          column: 10
        },
        end: {
          line: 164,
          column: 11
        }
      },
      "55": {
        start: {
          line: 162,
          column: 12
        },
        end: {
          line: 162,
          column: 74
        }
      },
      "56": {
        start: {
          line: 163,
          column: 12
        },
        end: {
          line: 163,
          column: 47
        }
      },
      "57": {
        start: {
          line: 167,
          column: 26
        },
        end: {
          line: 171,
          column: 12
        }
      },
      "58": {
        start: {
          line: 168,
          column: 12
        },
        end: {
          line: 168,
          column: 34
        }
      },
      "59": {
        start: {
          line: 169,
          column: 12
        },
        end: {
          line: 169,
          column: 57
        }
      },
      "60": {
        start: {
          line: 169,
          column: 32
        },
        end: {
          line: 169,
          column: 57
        }
      },
      "61": {
        start: {
          line: 170,
          column: 12
        },
        end: {
          line: 170,
          column: 53
        }
      },
      "62": {
        start: {
          line: 172,
          column: 10
        },
        end: {
          line: 172,
          column: 69
        }
      },
      "63": {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 175,
          column: 12
        }
      },
      "64": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      },
      "65": {
        start: {
          line: 180,
          column: 24
        },
        end: {
          line: 180,
          column: 49
        }
      },
      "66": {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 181,
          column: 32
        }
      },
      "67": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 55
        }
      },
      "68": {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 184,
          column: 37
        }
      },
      "69": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 34
        }
      },
      "70": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 86
        }
      },
      "71": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 189,
          column: 12
        }
      },
      "72": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 192,
          column: 93
        }
      },
      "73": {
        start: {
          line: 193,
          column: 4
        },
        end: {
          line: 195,
          column: 5
        }
      },
      "74": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 194,
          column: 62
        }
      },
      "75": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 198,
          column: 5
        }
      },
      "76": {
        start: {
          line: 197,
          column: 6
        },
        end: {
          line: 197,
          column: 62
        }
      },
      "77": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 211,
          column: 5
        }
      },
      "78": {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 202,
          column: 40
        }
      },
      "79": {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 203,
          column: 69
        }
      },
      "80": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 45
        }
      },
      "81": {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 205,
          column: 31
        }
      },
      "82": {
        start: {
          line: 209,
          column: 8
        },
        end: {
          line: 209,
          column: 114
        }
      },
      "83": {
        start: {
          line: 215,
          column: 25
        },
        end: {
          line: 215,
          column: 35
        }
      },
      "84": {
        start: {
          line: 216,
          column: 26
        },
        end: {
          line: 216,
          column: 36
        }
      },
      "85": {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 219,
          column: 5
        }
      },
      "86": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 218,
          column: 47
        }
      },
      "87": {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 16
        }
      },
      "88": {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 224,
          column: 45
        }
      },
      "89": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 102
        }
      },
      "90": {
        start: {
          line: 230,
          column: 76
        },
        end: {
          line: 230,
          column: 86
        }
      },
      "91": {
        start: {
          line: 231,
          column: 22
        },
        end: {
          line: 231,
          column: 47
        }
      },
      "92": {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 271,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 33
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 52
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 44
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 73
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 85,
            column: 3
          }
        },
        loc: {
          start: {
            line: 85,
            column: 15
          },
          end: {
            line: 88,
            column: 3
          }
        },
        line: 85
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 40
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 90
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 41
          },
          end: {
            line: 96,
            column: 3
          }
        },
        line: 94
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 29
          },
          end: {
            line: 104,
            column: 3
          }
        },
        line: 98
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 106,
            column: 2
          },
          end: {
            line: 106,
            column: 3
          }
        },
        loc: {
          start: {
            line: 106,
            column: 37
          },
          end: {
            line: 119,
            column: 3
          }
        },
        line: 106
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 122,
            column: 2
          },
          end: {
            line: 122,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 212,
            column: 3
          }
        },
        line: 130
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 136,
            column: 48
          },
          end: {
            line: 136,
            column: 49
          }
        },
        loc: {
          start: {
            line: 136,
            column: 57
          },
          end: {
            line: 138,
            column: 7
          }
        },
        line: 136
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 146,
            column: 14
          },
          end: {
            line: 146,
            column: 15
          }
        },
        loc: {
          start: {
            line: 146,
            column: 23
          },
          end: {
            line: 165,
            column: 9
          }
        },
        line: 146
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 9
          }
        },
        loc: {
          start: {
            line: 166,
            column: 14
          },
          end: {
            line: 173,
            column: 9
          }
        },
        line: 166
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 167,
            column: 50
          },
          end: {
            line: 167,
            column: 51
          }
        },
        loc: {
          start: {
            line: 167,
            column: 59
          },
          end: {
            line: 171,
            column: 11
          }
        },
        line: 167
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 201,
            column: 12
          },
          end: {
            line: 201,
            column: 13
          }
        },
        loc: {
          start: {
            line: 201,
            column: 21
          },
          end: {
            line: 206,
            column: 7
          }
        },
        line: 201
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 207,
            column: 6
          },
          end: {
            line: 207,
            column: 7
          }
        },
        loc: {
          start: {
            line: 207,
            column: 12
          },
          end: {
            line: 210,
            column: 7
          }
        },
        line: 207
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 214,
            column: 2
          },
          end: {
            line: 214,
            column: 3
          }
        },
        loc: {
          start: {
            line: 214,
            column: 49
          },
          end: {
            line: 221,
            column: 3
          }
        },
        line: 214
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 3
          }
        },
        loc: {
          start: {
            line: 223,
            column: 38
          },
          end: {
            line: 226,
            column: 3
          }
        },
        line: 223
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 228,
            column: 2
          },
          end: {
            line: 228,
            column: 3
          }
        },
        loc: {
          start: {
            line: 228,
            column: 11
          },
          end: {
            line: 272,
            column: 3
          }
        },
        line: 228
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }, {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }],
        line: 75
      },
      "1": {
        loc: {
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 78,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 76,
            column: 6
          },
          end: {
            line: 76,
            column: 28
          }
        }, {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 54
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 59
          }
        }],
        line: 76
      },
      "2": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }],
        line: 100
      },
      "3": {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 107,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 107,
            column: 46
          }
        }, {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 107,
            column: 46
          }
        }],
        line: 107
      },
      "4": {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 21
          }
        }, {
          start: {
            line: 107,
            column: 25
          },
          end: {
            line: 107,
            column: 38
          }
        }],
        line: 107
      },
      "5": {
        loc: {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }, {
          start: {
            line: 110,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        }],
        line: 110
      },
      "6": {
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 112,
            column: 68
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 112,
            column: 68
          }
        }, {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 112,
            column: 68
          }
        }],
        line: 111
      },
      "7": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }],
        line: 114
      },
      "8": {
        loc: {
          start: {
            line: 117,
            column: 21
          },
          end: {
            line: 117,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 117,
            column: 59
          },
          end: {
            line: 117,
            column: 60
          }
        }, {
          start: {
            line: 117,
            column: 63
          },
          end: {
            line: 117,
            column: 73
          }
        }],
        line: 117
      },
      "9": {
        loc: {
          start: {
            line: 131,
            column: 19
          },
          end: {
            line: 131,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 131,
            column: 26
          },
          end: {
            line: 131,
            column: 63
          }
        }, {
          start: {
            line: 131,
            column: 66
          },
          end: {
            line: 131,
            column: 68
          }
        }],
        line: 131
      },
      "10": {
        loc: {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 141,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 141,
            column: 5
          }
        }, {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 141,
            column: 5
          }
        }],
        line: 135
      },
      "11": {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }],
        line: 143
      },
      "12": {
        loc: {
          start: {
            line: 149,
            column: 10
          },
          end: {
            line: 156,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 10
          },
          end: {
            line: 156,
            column: 11
          }
        }, {
          start: {
            line: 149,
            column: 10
          },
          end: {
            line: 156,
            column: 11
          }
        }],
        line: 149
      },
      "13": {
        loc: {
          start: {
            line: 150,
            column: 12
          },
          end: {
            line: 154,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 150,
            column: 12
          },
          end: {
            line: 154,
            column: 13
          }
        }, {
          start: {
            line: 150,
            column: 12
          },
          end: {
            line: 154,
            column: 13
          }
        }],
        line: 150
      },
      "14": {
        loc: {
          start: {
            line: 150,
            column: 16
          },
          end: {
            line: 150,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 16
          },
          end: {
            line: 150,
            column: 17
          }
        }, {
          start: {
            line: 150,
            column: 21
          },
          end: {
            line: 150,
            column: 50
          }
        }],
        line: 150
      },
      "15": {
        loc: {
          start: {
            line: 151,
            column: 14
          },
          end: {
            line: 153,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 151,
            column: 14
          },
          end: {
            line: 153,
            column: 15
          }
        }, {
          start: {
            line: 151,
            column: 14
          },
          end: {
            line: 153,
            column: 15
          }
        }],
        line: 151
      },
      "16": {
        loc: {
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 160,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 160,
            column: 11
          }
        }, {
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 160,
            column: 11
          }
        }],
        line: 157
      },
      "17": {
        loc: {
          start: {
            line: 157,
            column: 14
          },
          end: {
            line: 157,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 14
          },
          end: {
            line: 157,
            column: 19
          }
        }, {
          start: {
            line: 157,
            column: 23
          },
          end: {
            line: 157,
            column: 51
          }
        }],
        line: 157
      },
      "18": {
        loc: {
          start: {
            line: 161,
            column: 10
          },
          end: {
            line: 164,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 10
          },
          end: {
            line: 164,
            column: 11
          }
        }, {
          start: {
            line: 161,
            column: 10
          },
          end: {
            line: 164,
            column: 11
          }
        }],
        line: 161
      },
      "19": {
        loc: {
          start: {
            line: 161,
            column: 14
          },
          end: {
            line: 161,
            column: 114
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 161,
            column: 14
          },
          end: {
            line: 161,
            column: 39
          }
        }, {
          start: {
            line: 161,
            column: 43
          },
          end: {
            line: 161,
            column: 114
          }
        }],
        line: 161
      },
      "20": {
        loc: {
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 169,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 169,
            column: 57
          }
        }, {
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 169,
            column: 57
          }
        }],
        line: 169
      },
      "21": {
        loc: {
          start: {
            line: 170,
            column: 31
          },
          end: {
            line: 170,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 31
          },
          end: {
            line: 170,
            column: 47
          }
        }, {
          start: {
            line: 170,
            column: 51
          },
          end: {
            line: 170,
            column: 53
          }
        }],
        line: 170
      },
      "22": {
        loc: {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }, {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 190,
            column: 5
          }
        }],
        line: 178
      },
      "23": {
        loc: {
          start: {
            line: 182,
            column: 29
          },
          end: {
            line: 182,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 182,
            column: 29
          },
          end: {
            line: 182,
            column: 49
          }
        }, {
          start: {
            line: 182,
            column: 53
          },
          end: {
            line: 182,
            column: 55
          }
        }],
        line: 182
      },
      "24": {
        loc: {
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        }, {
          start: {
            line: 193,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        }],
        line: 193
      },
      "25": {
        loc: {
          start: {
            line: 193,
            column: 8
          },
          end: {
            line: 193,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 193,
            column: 8
          },
          end: {
            line: 193,
            column: 11
          }
        }, {
          start: {
            line: 193,
            column: 15
          },
          end: {
            line: 193,
            column: 50
          }
        }],
        line: 193
      },
      "26": {
        loc: {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }, {
          start: {
            line: 196,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }],
        line: 196
      },
      "27": {
        loc: {
          start: {
            line: 196,
            column: 8
          },
          end: {
            line: 196,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 196,
            column: 8
          },
          end: {
            line: 196,
            column: 11
          }
        }, {
          start: {
            line: 196,
            column: 15
          },
          end: {
            line: 196,
            column: 50
          }
        }],
        line: 196
      },
      "28": {
        loc: {
          start: {
            line: 203,
            column: 37
          },
          end: {
            line: 203,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 37
          },
          end: {
            line: 203,
            column: 63
          }
        }, {
          start: {
            line: 203,
            column: 67
          },
          end: {
            line: 203,
            column: 69
          }
        }],
        line: 203
      },
      "29": {
        loc: {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        }, {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 219,
            column: 5
          }
        }],
        line: 217
      },
      "30": {
        loc: {
          start: {
            line: 243,
            column: 17
          },
          end: {
            line: 243,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 243,
            column: 45
          },
          end: {
            line: 243,
            column: 50
          }
        }, {
          start: {
            line: 243,
            column: 53
          },
          end: {
            line: 243,
            column: 62
          }
        }],
        line: 243
      },
      "31": {
        loc: {
          start: {
            line: 257,
            column: 15
          },
          end: {
            line: 257,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 257,
            column: 30
          },
          end: {
            line: 257,
            column: 42
          }
        }, {
          start: {
            line: 257,
            column: 45
          },
          end: {
            line: 257,
            column: 48
          }
        }],
        line: 257
      },
      "32": {
        loc: {
          start: {
            line: 260,
            column: 17
          },
          end: {
            line: 260,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 260,
            column: 45
          },
          end: {
            line: 260,
            column: 50
          }
        }, {
          start: {
            line: 260,
            column: 53
          },
          end: {
            line: 260,
            column: 62
          }
        }],
        line: 260
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/DatePicker/Range.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import shallowEqual from '../utils/shallowEqual';
import utils from './utils';
import { getLocale } from '../locale';
import paramUtils from './paramUtils';
import Picker from './Picker';
import { datepickerClass } from './styles';
import Quick from './Quick';
var DefaultValue = (cov_1hrh1reqyt.s[0]++, {
  value: []
});

var Range =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Range, _PureComponent);

  var _super = _createSuper2(Range);

  function Range(props) {
    var _this;

    _classCallCheck(this, Range);

    cov_1hrh1reqyt.f[0]++;
    cov_1hrh1reqyt.s[1]++;
    _this = _super.call(this, props);
    _this.pickers = void 0;
    _this.handleFirstChange = void 0;
    _this.handleSecondChange = void 0;
    _this.bindFirstPicker = void 0;
    _this.bindSecondPicker = void 0;
    _this.handleDisabledStart = void 0;
    _this.handleDisabledEnd = void 0;
    cov_1hrh1reqyt.s[2]++;
    _this.state = {
      rangeDate: props.value
    };
    cov_1hrh1reqyt.s[3]++;
    _this.pickers = [];
    cov_1hrh1reqyt.s[4]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_1hrh1reqyt.s[5]++;
    _this.handleFirstChange = _this.handleChange.bind(_assertThisInitialized(_this), 0);
    cov_1hrh1reqyt.s[6]++;
    _this.handleSecondChange = _this.handleChange.bind(_assertThisInitialized(_this), 1);
    cov_1hrh1reqyt.s[7]++;
    _this.handleDayHover = _this.handleDayHover.bind(_assertThisInitialized(_this));
    cov_1hrh1reqyt.s[8]++;
    _this.bindFirstPicker = _this.bindPicker.bind(_assertThisInitialized(_this), 0);
    cov_1hrh1reqyt.s[9]++;
    _this.bindSecondPicker = _this.bindPicker.bind(_assertThisInitialized(_this), 1);
    cov_1hrh1reqyt.s[10]++;
    _this.handleDisabledStart = _this.handleDisabled.bind(_assertThisInitialized(_this), 'start');
    cov_1hrh1reqyt.s[11]++;
    _this.handleDisabledEnd = _this.handleDisabled.bind(_assertThisInitialized(_this), 'end');
    cov_1hrh1reqyt.s[12]++;
    _this.changeDateSmart = _this.changeDateSmart.bind(_assertThisInitialized(_this));
    cov_1hrh1reqyt.s[13]++;
    _this.handleQuick = _this.handleQuick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Range, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_1hrh1reqyt.f[1]++;

      var _ref = (cov_1hrh1reqyt.s[14]++, this.state),
          rangeDate = _ref.rangeDate;

      cov_1hrh1reqyt.s[15]++;

      if ((cov_1hrh1reqyt.b[1][0]++, rangeDate.length !== 1) && (cov_1hrh1reqyt.b[1][1]++, !shallowEqual(prevProps.value, this.props.value)) && (cov_1hrh1reqyt.b[1][2]++, !shallowEqual(this.state.rangeDate, this.props.value))) {
        cov_1hrh1reqyt.b[0][0]++;
        cov_1hrh1reqyt.s[16]++;
        // eslint-disable-next-line
        this.setState({
          rangeDate: this.props.value
        });
      } else {
        cov_1hrh1reqyt.b[0][1]++;
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      cov_1hrh1reqyt.f[2]++;

      var _ref2 = (cov_1hrh1reqyt.s[17]++, this.props),
          timeZone = _ref2.timeZone;

      cov_1hrh1reqyt.s[18]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "bindPicker",
    value: function bindPicker(index, el) {
      cov_1hrh1reqyt.f[3]++;
      cov_1hrh1reqyt.s[19]++;
      this.pickers[index] = el;
    }
  }, {
    key: "resetRange",
    value: function resetRange(rangeDate) {
      cov_1hrh1reqyt.f[4]++;
      cov_1hrh1reqyt.s[20]++;
      this.setState({
        rangeDate: rangeDate
      });
    }
  }, {
    key: "handleDayHover",
    value: function handleDayHover(date) {
      cov_1hrh1reqyt.f[5]++;
      cov_1hrh1reqyt.s[21]++;

      // will never in
      if (this.state.rangeDate.length === 1) {
        cov_1hrh1reqyt.b[2][0]++;
        cov_1hrh1reqyt.s[22]++;
        utils.cloneTime(date, this.props.value[1], this.props.format, this.getOptions()); // this.setState({ hover: date })
      } else {
        cov_1hrh1reqyt.b[2][1]++;
      }
    }
  }, {
    key: "changeDateSmart",
    value: function changeDateSmart(rangeDate) {
      cov_1hrh1reqyt.f[6]++;
      cov_1hrh1reqyt.s[23]++;

      if ((cov_1hrh1reqyt.b[4][0]++, !rangeDate[0]) || (cov_1hrh1reqyt.b[4][1]++, !rangeDate[1])) {
        cov_1hrh1reqyt.b[3][0]++;
        cov_1hrh1reqyt.s[24]++;
        return;
      } else {
        cov_1hrh1reqyt.b[3][1]++;
      }

      var _ref3 = (cov_1hrh1reqyt.s[25]++, rangeDate),
          _ref4 = _slicedToArray(_ref3, 2),
          s = _ref4[0],
          e = _ref4[1];

      var _ref5 = (cov_1hrh1reqyt.s[26]++, this.props),
          range = _ref5.range;

      cov_1hrh1reqyt.s[27]++;

      if (typeof range === 'number') {
        cov_1hrh1reqyt.b[5][0]++;
        cov_1hrh1reqyt.s[28]++;

        if (utils.compareAsc(s, utils.addSeconds(e, -range, this.getOptions())) < 0) {
          cov_1hrh1reqyt.b[6][0]++;
          cov_1hrh1reqyt.s[29]++;
          rangeDate[1] = utils.addSeconds(s, range, this.getOptions());
        } else {
          cov_1hrh1reqyt.b[6][1]++;
        }
      } else {
        cov_1hrh1reqyt.b[5][1]++;
      }

      cov_1hrh1reqyt.s[30]++;

      if (utils.compareAsc(s, e) > 0) {
        cov_1hrh1reqyt.b[7][0]++;
        var sWitheTime = (cov_1hrh1reqyt.s[31]++, utils.toDate(s, this.getOptions()));
        cov_1hrh1reqyt.s[32]++;
        sWitheTime = utils.setTime(sWitheTime, e, this.getOptions());
        cov_1hrh1reqyt.s[33]++;
        rangeDate[1] = utils.compareAsc(s, sWitheTime) > 0 ? (cov_1hrh1reqyt.b[8][0]++, s) : (cov_1hrh1reqyt.b[8][1]++, sWitheTime);
      } else {
        cov_1hrh1reqyt.b[7][1]++;
      }
    } // Be consistent with the parent onChange, expand first params: index

  }, {
    key: "handleChange",
    value: function handleChange(index, date, change, _blur, _isEnd, _isQuickSelect, areaType) {
      var _this2 = this;

      cov_1hrh1reqyt.f[7]++;
      var newDate = (cov_1hrh1reqyt.s[34]++, date ? (cov_1hrh1reqyt.b[9][0]++, utils.toDate(date, this.getOptions())) : (cov_1hrh1reqyt.b[9][1]++, ''));

      var _ref6 = (cov_1hrh1reqyt.s[35]++, this.props),
          type = _ref6.type,
          range = _ref6.range,
          min = _ref6.min,
          max = _ref6.max;

      var handleOnChangeParams = (cov_1hrh1reqyt.s[36]++, paramUtils.handleOnChangeParams(areaType));
      cov_1hrh1reqyt.s[37]++;

      if (!change) {
        var _this$props;

        cov_1hrh1reqyt.b[10][0]++;
        var current = (cov_1hrh1reqyt.s[38]++, immer(this.props.current, function (draft) {
          cov_1hrh1reqyt.f[8]++;
          cov_1hrh1reqyt.s[39]++;
          draft[index] = newDate;
        }));
        cov_1hrh1reqyt.s[40]++;

        (_this$props = this.props).onChange.apply(_this$props, _toConsumableArray(handleOnChangeParams(current)));

        cov_1hrh1reqyt.s[41]++;
        return;
      } else {
        cov_1hrh1reqyt.b[10][1]++;
      }

      cov_1hrh1reqyt.s[42]++;

      if (areaType === 'time') {
        cov_1hrh1reqyt.b[11][0]++;
        var endChangedDate;
        cov_1hrh1reqyt.s[43]++;
        this.setState(immer(function (draft) {
          cov_1hrh1reqyt.f[9]++;
          cov_1hrh1reqyt.s[44]++;
          draft.rangeDate[index] = newDate;

          var _ref7 = (cov_1hrh1reqyt.s[45]++, draft.rangeDate),
              _ref8 = _slicedToArray(_ref7, 2),
              s = _ref8[0],
              e = _ref8[1];

          cov_1hrh1reqyt.s[46]++;

          if (index !== 0) {
            cov_1hrh1reqyt.b[12][0]++;
            cov_1hrh1reqyt.s[47]++;

            if ((cov_1hrh1reqyt.b[14][0]++, s) && (cov_1hrh1reqyt.b[14][1]++, s.getHours() === e.getHours())) {
              cov_1hrh1reqyt.b[13][0]++;
              cov_1hrh1reqyt.s[48]++;

              if (utils.compareAsc(s, e) === 1) {
                cov_1hrh1reqyt.b[15][0]++;
                cov_1hrh1reqyt.s[49]++;
                e.setMinutes(s.getMinutes());
              } else {
                cov_1hrh1reqyt.b[15][1]++;
              }
            } else {
              cov_1hrh1reqyt.b[13][1]++;
            }

            cov_1hrh1reqyt.s[50]++;
            return;
          } else {
            cov_1hrh1reqyt.b[12][1]++;
          }

          cov_1hrh1reqyt.s[51]++;

          if ((cov_1hrh1reqyt.b[17][0]++, range) && (cov_1hrh1reqyt.b[17][1]++, utils.compareAsc(s, e) === 1)) {
            cov_1hrh1reqyt.b[16][0]++;
            cov_1hrh1reqyt.s[52]++;
            endChangedDate = newDate;
            cov_1hrh1reqyt.s[53]++;
            draft.rangeDate[1] = endChangedDate;
          } else {
            cov_1hrh1reqyt.b[16][1]++;
          }

          cov_1hrh1reqyt.s[54]++;

          if ((cov_1hrh1reqyt.b[19][0]++, typeof range === 'number') && (cov_1hrh1reqyt.b[19][1]++, utils.compareAsc(s, utils.addSeconds(e, -range, _this2.getOptions())) < 0)) {
            cov_1hrh1reqyt.b[18][0]++;
            cov_1hrh1reqyt.s[55]++;
            endChangedDate = utils.addSeconds(s, range, _this2.getOptions());
            cov_1hrh1reqyt.s[56]++;
            draft.rangeDate[1] = endChangedDate;
          } else {
            cov_1hrh1reqyt.b[18][1]++;
          }
        }), function () {
          var _this2$props;

          cov_1hrh1reqyt.f[10]++;
          var current = (cov_1hrh1reqyt.s[57]++, immer(_this2.props.value, function (draft) {
            cov_1hrh1reqyt.f[11]++;
            cov_1hrh1reqyt.s[58]++;
            draft[index] = newDate;
            cov_1hrh1reqyt.s[59]++;

            if (endChangedDate) {
              cov_1hrh1reqyt.b[20][0]++;
              cov_1hrh1reqyt.s[60]++;
              draft[1] = endChangedDate;
            } else {
              cov_1hrh1reqyt.b[20][1]++;
            }

            cov_1hrh1reqyt.s[61]++;
            draft[1 - index] = (cov_1hrh1reqyt.b[21][0]++, draft[1 - index]) || (cov_1hrh1reqyt.b[21][1]++, '');
          }));
          cov_1hrh1reqyt.s[62]++;

          (_this2$props = _this2.props).onChange.apply(_this2$props, _toConsumableArray(handleOnChangeParams(current, true)));
        });
        cov_1hrh1reqyt.s[63]++;
        return;
      } else {
        cov_1hrh1reqyt.b[11][1]++;
      }

      cov_1hrh1reqyt.s[64]++;

      if (type === 'month') {
        var _this$props2;

        cov_1hrh1reqyt.b[22][0]++;

        // eslint-disable-next-line
        var _rangeDate = (cov_1hrh1reqyt.s[65]++, _toConsumableArray(this.state.rangeDate));

        cov_1hrh1reqyt.s[66]++;
        _rangeDate[index] = newDate;
        cov_1hrh1reqyt.s[67]++;
        _rangeDate[1 - index] = (cov_1hrh1reqyt.b[23][0]++, _rangeDate[1 - index]) || (cov_1hrh1reqyt.b[23][1]++, '');
        cov_1hrh1reqyt.s[68]++;
        this.changeDateSmart(_rangeDate);
        cov_1hrh1reqyt.s[69]++;
        this.setState({
          rangeDate: _rangeDate
        });
        cov_1hrh1reqyt.s[70]++;

        (_this$props2 = this.props).onChange.apply(_this$props2, _toConsumableArray(handleOnChangeParams(_rangeDate, true, true, index === 1)));

        cov_1hrh1reqyt.s[71]++;
        return;
      } else {
        cov_1hrh1reqyt.b[22][1]++;
      }

      cov_1hrh1reqyt.s[72]++;
      newDate = utils.cloneTime(newDate, this.props.value[index], undefined, this.getOptions());
      cov_1hrh1reqyt.s[73]++;

      if ((cov_1hrh1reqyt.b[25][0]++, min) && (cov_1hrh1reqyt.b[25][1]++, utils.compareAsc(newDate, min) <= 0)) {
        cov_1hrh1reqyt.b[24][0]++;
        cov_1hrh1reqyt.s[74]++;
        newDate = utils.setTime(newDate, min, this.getOptions());
      } else {
        cov_1hrh1reqyt.b[24][1]++;
      }

      cov_1hrh1reqyt.s[75]++;

      if ((cov_1hrh1reqyt.b[27][0]++, max) && (cov_1hrh1reqyt.b[27][1]++, utils.compareAsc(newDate, max) >= 0)) {
        cov_1hrh1reqyt.b[26][0]++;
        cov_1hrh1reqyt.s[76]++;
        newDate = utils.setTime(newDate, max, this.getOptions());
      } else {
        cov_1hrh1reqyt.b[26][1]++;
      }

      cov_1hrh1reqyt.s[77]++;
      this.setState(immer(function (draft) {
        cov_1hrh1reqyt.f[12]++;
        cov_1hrh1reqyt.s[78]++;
        draft.rangeDate[index] = newDate;
        cov_1hrh1reqyt.s[79]++;
        draft.rangeDate[1 - index] = (cov_1hrh1reqyt.b[28][0]++, draft.rangeDate[1 - index]) || (cov_1hrh1reqyt.b[28][1]++, '');
        cov_1hrh1reqyt.s[80]++;

        _this2.changeDateSmart(draft.rangeDate);

        cov_1hrh1reqyt.s[81]++;
        draft.hover = undefined;
      }), function () {
        var _this2$props2;

        cov_1hrh1reqyt.f[13]++;
        cov_1hrh1reqyt.s[82]++;

        // only 'datetime' don not need close, 'time is up'
        (_this2$props2 = _this2.props).onChange.apply(_this2$props2, _toConsumableArray(handleOnChangeParams(_this2.state.rangeDate, true, type !== 'datetime', index === 1)));
      });
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(type, date) {
      cov_1hrh1reqyt.f[14]++;

      var _ref9 = (cov_1hrh1reqyt.s[83]++, this.props),
          disabled = _ref9.disabled;

      var _ref10 = (cov_1hrh1reqyt.s[84]++, this.state),
          rangeDate = _ref10.rangeDate;

      cov_1hrh1reqyt.s[85]++;

      if (disabled) {
        cov_1hrh1reqyt.b[29][0]++;
        cov_1hrh1reqyt.s[86]++;
        return disabled.apply(void 0, [date, type].concat(_toConsumableArray(rangeDate)));
      } else {
        cov_1hrh1reqyt.b[29][1]++;
      }

      cov_1hrh1reqyt.s[87]++;
      return false;
    }
  }, {
    key: "handleQuick",
    value: function handleQuick(quick) {
      var _this$props3;

      cov_1hrh1reqyt.f[15]++;
      cov_1hrh1reqyt.s[88]++;
      this.setState({
        rangeDate: quick.value
      });
      cov_1hrh1reqyt.s[89]++;

      (_this$props3 = this.props).onChange.apply(_this$props3, _toConsumableArray(paramUtils.quickHandleChangeParams(quick.value, true, false, false, quick)));
    }
  }, {
    key: "render",
    value: function render() {
      cov_1hrh1reqyt.f[16]++;

      // min & max can not to child
      var _ref11 = (cov_1hrh1reqyt.s[90]++, this.props),
          current = _ref11.current,
          value = _ref11.value,
          range = _ref11.range,
          children = _ref11.children,
          min = _ref11.min,
          max = _ref11.max,
          quicks = _ref11.quicks,
          props = _objectWithoutProperties(_ref11, ["current", "value", "range", "children", "min", "max", "quicks"]);

      var rangeDate = (cov_1hrh1reqyt.s[91]++, _toConsumableArray(this.state.rangeDate));
      cov_1hrh1reqyt.s[92]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('range-picker'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 233,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Quick, Object.assign({}, this.props, {
          current: this.state.rangeDate,
          onChange: this.handleQuick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 234,
            columnNumber: 9
          }
        })),
        /*#__PURE__*/
        React.createElement(Picker, Object.assign({}, props, {
          pos: "start",
          disabled: this.handleDisabledStart,
          index: 0,
          min: min,
          max: max,
          current: current[0],
          range: typeof range === 'number' ? (cov_1hrh1reqyt.b[30][0]++, range) : (cov_1hrh1reqyt.b[30][1]++, undefined),
          rangeDate: rangeDate,
          rangeTemp: rangeDate[0],
          onChange: this.handleFirstChange,
          onChangeSync: this.handleChange,
          onDayHover: this.handleDayHover,
          ref: this.bindFirstPicker,
          value: utils.toDateWithFormat(value[0], props.format, undefined, this.getOptions()),
          showTimePicker: value.length === 2,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 235,
            columnNumber: 9
          }
        })),
        /*#__PURE__*/
        React.createElement(Picker, Object.assign({}, props, {
          disabled: this.handleDisabledEnd,
          index: 1,
          min: rangeDate[0] ? (cov_1hrh1reqyt.b[31][0]++, rangeDate[0]) : (cov_1hrh1reqyt.b[31][1]++, min),
          max: max,
          current: current[1],
          range: typeof range === 'number' ? (cov_1hrh1reqyt.b[32][0]++, range) : (cov_1hrh1reqyt.b[32][1]++, undefined),
          rangeDate: rangeDate,
          rangeTemp: rangeDate[0],
          onChange: this.handleSecondChange,
          onChangeSync: this.handleChange,
          onDayHover: this.handleDayHover,
          ref: this.bindSecondPicker,
          value: utils.toDateWithFormat(value[1], props.format, undefined, this.getOptions()),
          showTimePicker: value.length === 2,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 253,
            columnNumber: 9
          }
        })))
      );
    }
  }]);

  return Range;
}(PureComponent);

Range.defaultProps = DefaultValue;
export default Range;